import { Link } from 'react-router-dom';
import urlEncode from '../urlEncode';

const convertToResults = function convertDataToResultsDataFormat(
  data,
  match,
  type,
  showModal
) {
  if (data) {
    return data.map(item => ({
      title: item.name,
      image: `https://www.twr360.org/images/sized/${
        item.logo ? item.logo : item.image
      }/c50x50/thumb.jpg?p=files/library`,
      as: Link,
      to:
        type === 'genre'
          ? `/stations/${urlEncode(item.name)}`
          : `${match.url}/${urlEncode(item.name)}`,
      onClick: () => showModal()
    }));
  }
  return [];
};

export default convertToResults;
